<template>
  <div 
    id="events"
    class="mx-n2"
  >
    <v-tabs
      v-model="controller.tabs.selected"
      background-color="transparent"
      color="primary"
      fixed-tabs
    >
      <v-tab>
        {{ $t('events.next') }}
      </v-tab>
      <v-tab>
        {{ $t('events.previous') }}
      </v-tab>
    </v-tabs>
    <v-divider class="ma-0" />

    <v-tabs-items 
      v-model="controller.tabs.selected"
      class="content fill-height"
      style="background: transparent;"
    >
      <v-tab-item 
        v-for="tab in controller.tabs.items"
        :key="'tab-'+tab"
        :ref="'tab-'+tab"
        class="scrollable fill-height px-4"
      >
        <v-card
          v-for="event in list[tab]"
          :key="'event-'+event.id"
          :ref="'event-'+event.id"
          :elevation="event.status=='active' ? 8 : event.status=='future' ? 4 : 2"
          :disabled="event.status=='past'"
          class="item mt-4 mb-2"
          :class="[event.status]"
        >
          <v-list>
            <h3 
              :class="[(event.status=='past' ? 'grey' :  'secondary')+'--text text--lighten-2']"
              class="text-h5 font-weight-medium px-4 py-1"
            >
              {{ event.subtitle }}
            </h3>
            <p 
              :class="[(event.status=='past' ? 'grey' : 'secondary')+'--text text--lighten-1']"
              class="text-h6 subtitle px-4 mb-2"
            >
              {{ event.title }}
            </p>
            <!-- <v-divider class="mx-4" /> -->
            <v-list-item
              v-for="(brief, key) in event.briefing"
              :key="'event-'+event.id+'-field-'+key"
              :class="{ 'd-none': brief.hidden }"
            >
              <v-list-item-content>
                <v-list-item-subtitle class="text-overline mb-2">{{ $t(brief.text) }}</v-list-item-subtitle>
                <v-list-item-title 
                  class="text text-untruncate"
                  :class="[('class' in brief ? brief.class : '')]"
                  v-html="brief.value" 
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div
            v-if="event.type=='SWR'&&event.status=='future'"
            class="slots grey darken-4 px-4 py-8"
          >
            <p class="text-h6 mb-3 text--lighten-1 secondary--text">
              {{ $t('events.choose_schedule') }}
            </p>
            <v-chip
              v-for="slot in availableSlots(event.slots)"
              :key="slot.id"
              :color="!!slot.driver&&slot.driver==driverId ? 'primary' : 'white'"
              :disabled="!!slot.driver&&slot.driver!=driverId"
              :outlined="!slot.driver"
              :close="!!slot.driver&&slot.driver==driverId"
              label
              :class="{ 'black--text': !!slot.driver&&slot.driver==driverId }"
              class="slot chip text-button mt-2 mr-2"
              @click:close="toggleConfirm('cancel', slot, event)"
              @click="toggleConfirm('confirm', slot, event)"
            >
              {{ $moment(slot.start).format('HH[h]') }}
            </v-chip>
          </div>
          <v-divider 
            v-if="!!event.acceptedAt&&event.status!='past'" 
            class="mx-4"
          />
          <v-card-actions 
            v-if="!!event.acceptedAt&&event.status!='past'"
          >
            <v-btn
              text
              color="warning"
              @click="report(event.id, event.title)"
            >
              {{ $t('events.report_problem') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="confirm.toggle"
      transition="slide-y-reverse-transition"
      persistent
      overlay-opacity=".8"
      open-delay="250"
    >
      <v-card color="black">
        <v-card-title>{{ $t('events.confirm.title') }}</v-card-title>
        <v-card-text class="py-4">
          <p class="text-body-1">
            {{ $t('events.confirm.text', { date: $moment(confirm.slot?.start).format('DD/MM'), start: $moment(confirm.slot?.start).format('HH'), end: $moment(confirm.slot?.end).format('HH') }) }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="grey"
            text
            :disabled="confirm.loading"
            @click="toggleConfirm('confirm', null);"
          >
            {{ $t('general.back') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="confirm.loading"
            @click="schedule"
          >
            {{ $t('general.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancel.toggle"
      transition="slide-y-reverse-transition"
      persistent
      overlay-opacity=".8"
      :open-delay="250"
    >
      <v-card color="black">
        <v-card-title>{{ $t('events.cancel') }}</v-card-title>
        <v-card-text class="py-4">
          <p class="text-body-1">
            {{ $t('events.cancel.text', { date: $moment(cancel.slot?.start).format('DD/MM'), start: $moment(cancel.slot?.start).format('HH'), end: $moment(cancel.slot?.end).format('HH') }) }}
          </p>
          <p class="body-1">
            {{ $t('events.cancel.warning') }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="grey lighten-1"
            text
            :disabled="cancel.loading"
            @click="toggleConfirm('cancel', null);"
          >
            {{ $t('general.back') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            text
            :loading="cancel.loading"
            @click="deschedule"
          >
            {{ $t('general.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay 
      v-model="loading"
      color="grey darken-4"
      absolute
      opacity=".9"
      z-index="2"
      class="loading-overlay text-center pt-8"
    >
      <loading class="loading mb-4" />
      <span class="d-block text-overline grey--text mb-2">
        {{ $t('general.loading') }}
      </span>
    </v-overlay>
  </div>
</template>

<style type="text/css">

  #events.sheet, #events .items {
    background: var(--v-background-base);
    min-height: 100%;
  }
  #events .scrollable {
    max-height: calc(100vh - 104px);
  }
  #events .item a {
    color: var(--v-secondary-base);
    font-weight: 500;
  }
  #events .item .text {
    line-height: 1.4;
  }

  #events .empty-state .text {
    opacity: .75;
  }

  #events .subtitle {
    opacity: .8;
  }

  #events .slots {
    position: sticky;
    bottom: 0;
  }
  #events .slot.chip {
    height: 36px;
  }

  #events .loading-overlay .loading {
    width: 48px;
    height: 48px;
    opacity: .8;
  }
  
</style>

<script>
  import { 
    mdiHelpCircleOutline, 
    mdiClose,
    mdiChevronLeft,
    mdiChevronRight,
    mdiGauge,
    mdiInformationOutline
  } from '@mdi/js';
  import { events } from '@/dictionary'
  import services from '@/services.js'
  import { sync, get } from 'vuex-pathify'
  import device from '@/device';


  export default {
    name: 'Events',

    props: {
      tickets: {
        type: Object,
        default: () => {}
      },
      // selected: {
      //   type: [String, Number],
      //   default: null
      // },
      loading: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        mdiHelpCircleOutline,
        mdiClose,
        mdiChevronLeft,
        mdiChevronRight,
        mdiGauge,
        mdiInformationOutline
      },
      controller: {
        tabs: {
          selected: 0,
          items: ['active', 'past']
        },
        brief: {
          state: {
            'active': ['directions', 'meeting_point', 'route', 'obs'],
            'future': ['date', 'location', 'reward', 'meeting_point', 'route', 'obs'],
            'past': ['date', 'location', 'reward'],
          },
          fields: [
            { 
              key: 'date', 
              start: 'mobilizesAt', 
              end: 'endsAt',
              text: 'events.date',
              omit: (e) => e.type!='FLS'
            },
            {
              key: 'date', 
              start: 'startsAt', 
              end: 'endsAt',
              text: 'events.date',
              omit: (e) => e.type=='FLS'
            },
            { 
              key: 'reward', 
              text: 'events.reward',
              prefix: 'general.currency_sign',
              omit: null
            }, 
            { 
              key: 'obs', 
              text: 'events.obs',
              omit: (e) => e.acceptedAt==null
            }, 
            { 
              key: 'location', 
              text: 'events.location', 
            }, 
            {
              key: 'directions', 
              text: 'events.directions',
              class: 'text-body-1',
              dates: ['startsAt', 'endsAt'],
              omit: null
            }, 
            { 
              key: 'meeting_point', 
              text: 'events.meeting_point',
              title: 'events.meeting_point_title',
              address: true,
              omit: (e) => e.type!='FLS'
            }, 
            { 
              key: 'route', 
              text: 'events.route',
              title: 'events.route_title',
              address: true,
              omit: null
            }
          ]
        },
      },
      confirm: {
        toggle: false,
        slot: null,
        loading: false
      },
      cancel: {
        toggle: false,
        slot: null,
        loading: false
      },
      loader: {
        loading: false,
        updatedAt: null,
        lazyness: [60, 'minutes']
      },
      dictionary: events
    }),

    computed: {
      events: sync('events/data@items'),
      // selected: sync('events/data@selected'),
      updatedAt: sync('events/data@updatedAt'),
      buzzer: sync('app/buzzer'),
      user: sync('user'),
      toast: sync('app/toast'),

      driverId () {
        return this.rawUsername(this.user?.username);
      },

      list () {
        const events = this.events;
        const lists = _.groupBy(_.map(events, event => {
          const status = this.eventStatus(event);
          return {
            ...event,
            status,
            title: event.title,
            subtitle: this.dictionary[event.type],
            briefing: this.briefing({ ...event, status })
          };
        }), event => event.status=='past' ? 'past' : 'active');
        return _.mapValues(lists, (list, status) => {
          return _.orderBy(list, ['status', 'mobilizesAt'], ['asc', status=='past' ? 'desc' : 'asc'])
        });
      },

      selected () {
        const route = this.$route;
        const id = route.query.event;
        const events = this.events;
        const event = !!id && id in events ? this.events[id] : null;
        return event;
      },

      hasActive () {
        return _.some(this.list, ['status', 'active']);
      },

      openedTickets () {
        return _.omitBy(this.tickets, 'closed');
      },

      pendingInvites () {
        const events = _.pickBy(this.events, event => this.eventStatus(event)=='future');
        const event_ids = _.keys(events);
        const tickets = this.openedTickets;
        return this.flashmobTickets(tickets, event_ids);
      },
    },

    watch: {
      selected (event) {
        if (!!event) {
          this.$nextTick(() => {
            const element = _.get(this.$refs['event-'+event.id], '[0].$el');
            element.scrollIntoView({ behavior: 'instant', inline: 'center', block: 'nearest' });
          });
        }
      }
    },

    methods: {
      ...services,

      briefing (event) {
        const controller = _.clone(this.controller.brief);
        const fields = _.cloneDeep(controller.fields);
        const state = _.has(controller.state, event.status) ? controller.state[event.status] : _.map(fields, 'key');
        return _.mapValues(_.pick(_.keyBy(fields, 'key'), state), (field, f) => {
          field.hidden = !!field.omit ? _.isBoolean(field.omit) ? field.omit : field.omit(event, this.$moment) : false;
          let value = event[f];
          switch (f) {
            case 'directions':
              const date = _.find(field.dates, d => {
                return this.$moment().isBefore(event[d]);
              });
              let text;
              if (event.type=='FLS') {
                switch (date) {
                  case 'startsAt':
                    text = this.$t('events.directions_start', { meet: this.$moment(event.mobilizesAt).format('HH:mm'), start: this.$moment(event.startsAt).format('HH:mm') });
                    field.value = text;
                    break;
  
                  case 'endsAt':
                    text = this.$t('events.directions_middle', { start: this.$moment(event.startsAt).format('HH:mm'), end: this.$moment(event.endsAt).format('HH:mm') });
                    field.value = text;
                    break;
                    
                  default:
                    text = this.$t('events.directions_end');
                    field.value = text;
                    break;
                }
              }else{
                const slot = _.reduce(_.orderBy(this.mySlots(event.slots), ['start'], ['asc']), (current, slot) => {
                  if (current.active?.end==slot.start) {
                    current.active.end = slot.end;
                  }else if (this.$moment().isAfter(slot.start)&&this.$moment().isBefore(slot.end)) {
                    current.active = slot;
                  }else if (this.$moment().isBefore(slot.start)) {
                    current.next = slot;
                  }
                  return current;
                }, { active: null, next: null });

                if (!!slot.active) {
                  text = this.$t('events.directions_middle', { start: this.$moment(slot.active.start).format('HH:mm'), end: this.$moment(slot.active.end).format('HH:mm') });
                }else if (!!slot.next) {
                  text = this.$t('events.directions_next', { start: this.$moment(slot.next.start).format('HH:mm') });
                }
                field.value = text;
              }

              break;
            
            case 'date':
              const start = event[field.start];
              const end = event[field.end];
              field.value = this.$moment(start).isValid() ? this.$moment(start).format('dddd DD/MM HH:mm').toUpperCase() + (this.$moment(end).isValid() ? ' - ' + this.$moment(end).format('HH:mm') : '') : 'A definir';
              break;
            
            case 'reward':
              if (event.type=='SWR') {
                const selected = this.mySlots(event.slots);
                value = selected.length ? `*${selected.length*value}* (${value} ${this.$tc('general.currency', value)}/${this.$tc('general.time', 1)})` : `*${value}/${this.$tc('general.time', 1)}*`;
              }
              field.value = !!value ? ('prefix' in field ? this.$t(field.prefix)+' ' : '') + value : this.$t('general.tbd');
              
              break;
            
            default:
              field.value = !!value ? ('prefix' in field ? this.$t(field.prefix)+' ' : '') + value : this.$t('general.tbd');
              if (!!value&&_.has(field, 'address')) {
                const isLink = /^(http|maps|geo)(.?):/gi.test(value);
                const link = isLink ? value : (device.isIOS ? 'geo' : 'maps')+':?q='+value
                field.value = `[${isLink ? this.$t(field.title) : value}](${link})^`
              }
          }
          field.value = this.formatText(field.value);
          return field;
        });
      },

      availableSlots (slots) {
        const driverId = this.driverId;
        const available = _.reduce(_.orderBy(slots, [s => s.driver==driverId ? 1 : 0, 'start'], ['desc', 'desc']), (available, slot) => {
          if ((slot.driver==null||slot.driver==driverId)&&!available.times.includes(slot.start)) {
            available.unique.push(slot);
            available.times.push(slot.start);
          }
          return available
        }, { unique: [], times: [] });
        return _.orderBy(available.unique, ['start'], ['asc']);
      },

      mySlots (slots) {
        const driverId = this.driverId;
        const selected = _.filter(slots, s => s.driver==driverId);
        return selected
      },

      toggleConfirm (type, slot=null, event=null) {
        const controller = this[type];
        controller.event = event;
        controller.slot = slot;
        controller.toggle = !!slot;
      },

      schedule () {
        const controller = this.confirm;
        console.log('events.schedule...', controller.slot);
        controller.loading = true;

        const id = controller.slot.id;

        this.$api.get('/driver/schedule/select/'+id+'/')
          .then(response => {
            console.log('events.schedule => ',response);
            if(response.data.retorno==200){
              this.toggleToast(
                true,
                this.$t('events.confirm.success'),
                5000,
                false,
              );

              // this.trackEvent('signup/'+this.stepName, 'confirm installation ok');
            }else if(response.data.retorno==404){
              this.toggleToast(
                true,
                this.$t('events.confirm.unavailable'),
                5000,
                false,
              );
              // this.trackEvent('signup/'+this.stepName, 'installation slot taken');
            }else{
              this.toggleToast(
                true,
                this.$t('events.confirm.error'),
                5000,
                false,
              );
              // this.trackEvent('signup/'+this.stepName, 'confirm installation failed');
            }
          })
          .catch(error => {
            this.handleError(error, this.$t('events.confirm.error'), true);
          })
          .finally(() => {
            this.getData();
            if (!controller.event.acceptedAt) {
              this.rsvpEvent(controller.event);
            }
            controller.toggle = false;
            controller.event = null;
            controller.slot = null;
            controller.loading = false;
          });
      },
      deschedule () {
        const controller = this.cancel;
        console.log('events.deschedule...', controller.slot);
        controller.loading = true;

        const id = controller.slot.id;

        this.$api.get('/driver/schedule/cancel', { params: { slot_id: id } })
          .then(response => {
            console.log('events.deschedule => ',response);
            if(response.data.retorno==200){
              this.toggleToast(
                true,
                this.$t('events.cancel.success'),
                5000,
                false,
              );

              // this.trackEvent('signup/'+this.stepName, 'confirm installation ok');
            }else{
              this.toggleToast(
                true,
                this.$t('events.cancel.error'),
                5000,
                false,
              );
              // this.trackEvent('signup/'+this.stepName, 'confirm installation failed');
            }
          })
          .catch(error => {
            this.handleError(error, this.$t('events.cancel.error'), true);
          })
          .finally(() => {
            this.getData();
            controller.toggle = false;
            controller.event = null;
            controller.slot = null;
            controller.loading = false;
          });
      },

      rsvpEvent (event, accepted=true) {
        // this.loading = true;
        
        const id_parceiro = this.user.profile.partner_id;
        const id_flashmob = event.id;
        const data = {
          id_parceiro,
          id_flashmob,
          accepted
        };

        console.log('rsvpEvent...', data);

        this.$api
          .post('/driver/events', data)
          .then(response => {
            console.log('rsvpEvent => ', response);
          })
          .catch(error => {
            if (error.response.status==401) {
              this.getout();
              this.toggleToast(
                true,
                'Sua sessão expirou...',
                5000,
                false
              );
            }else{
              // this.handleError(error, 'Erro desconhecido. Vamos investigar o que houve! 😊', true);
              // this.$emit('toggle-alert', 'Aguardando resposta do sistema... ⏳');
              // try again in 7s
              // this.view.loader = setTimeout(($) => {
              //   this.view.loader = null;
              //   $.getBenefits(script);
              // }, 7000, this, script);
            }
          })
          .finally(() => {
            // this.loading = false;
          });
      },

      eventStatus (event) {
        const start = event.mobilizesAt || event.startsAt;
        const end = event.demobilizesAt || event.endsAt;
        return !!end&&this.$moment().isAfter(end) ? 'past' : 
          !!start&&this.$moment().add(0,'h').isAfter(start)&&!!end&&this.$moment().isBefore(end) ? 'active' : 
            start==null||this.$moment().isBefore(start) ? 'future' : undefined;
      },

      flashmobTickets (tickets, events) {
        return _.filter(tickets, ticket => {
          return ticket.section=='flashmob'||(_.has(ticket, 'data')&&_.has(ticket.data, 'id_flashmob')&&_.indexOf(events, ticket.data.id_flashmob)>=0);
        });
      },

      checkPendingInvites () {
        const invites = this.pendingInvites;
        if (_.size(invites)>0) {
          this.$emit('open-ticket', _.first(invites).id);
        }
      },
      
      getData () {
        this.get();
      },

      shouldUpdate () {
        const loader = this.loader;
        console.log(loader.updatedAt, this.$moment(loader.updatedAt).add(...loader.lazyness));
        return (!loader.loading && loader.updatedAt==null) || this.$moment().isAfter(this.$moment(loader.updatedAt).add(...loader.lazyness));
      },

      report (id, title) {
        const tickets = _.orderBy(this.flashmobTickets(this.tickets, [id]), ['createdAt'], ['asc']);
        const ticket = _.size(tickets)>0 ? _.last(tickets) : null;
        const config = {
          data: {
            title
          },
          ...(_.isNil(ticket) ? { 
            section: 'flashmob',
            category: {
              value: 'Parceria',
              child: 'Flashmob'
            }
          } : {})
        };
        this.$emit('report', ticket.id, config);
      },

      get () {
        const loader = this.loader;
        const update = this.shouldUpdate();
        loader.loading = true;
        if (!update) {
          setTimeout((loader) => {
            loader.loading = false;
          }, 500, loader);
        }
        
        console.log('events.get...');
        this.$api
          .get('/driver/events/')
          .then(response => {
            console.log('events.get => ',response);

            this.events = Object.assign({}, _.keyBy(_.map(response.data, item => {
              const event = this.format(item, this.dictionary);
              const driver = _.first(event.drivers) || {};
              const { acceptedAt=null, declinedAt=null, invitedAt=null, uninvitedAt=null } = driver;
              return {
                ...event,
                acceptedAt, 
                declinedAt, 
                invitedAt, 
                uninvitedAt
              }
            }), 'id'));
            
            this.checkPendingInvites()
          })
          .catch(error => {
            if(error.response.status==401){
              this.getout();
              this.handleError(error, 'Sua sessão expirou...');
            }else{
              this.handleError(error, 'Aguardando resposta do sistema...');
              setTimeout(($) => {
                $.get();
              }, 5000, this);
            }
            loader.updatedAt = this.$moment().valueOf();
          })
          .finally(() => {
            loader.loading = false;
          });
      },
    },

    mounted () {
      this.loader.updatedAt = this.updatedAt;
      this.getData();
    },

    components: {
      Loading: () => import('@/components/IconLoading'),
      CalendarView: () => import('@/components/CalendarView'),
    },
  }
</script>
